import { ServiceLinkSection } from 'pages/Services/ServicePage.interfaces'
import { tabToEmsp } from '../../utils'

export const information = [
  {
    title: 'Vi har lösningen för just dig och ditt företag!',
    paragraphs: [
      'Med skräddarsydda lösningar som passar just dig och ditt företag förenklar vi ert fordonsägande. Vi ger er säkrare fordon, högre kvalitet, smidigare logistik, bättre fordonsekonomi, förbättrad kundnöjdhet och miljösmarta lösningar.',
      'Kontakta oss på <a href="mailto:kundportalen@opusbilprovning.se">kundportalen@opusbilprovning.se</a>',
      `${tabToEmsp('Mer än kontrollbesiktning!\t\t\t\tVi förenklar logistiken!')}`,
      `${tabToEmsp(
        '- <a href="https://opus.se/tjanster/efterkontroll/">Efterkontroll</a>&emsp;\t\t\t\t\t\t- <a href="https://opus.se/tjanster/hamta-lamna/">Hämta och lämna service</a>&emsp;&nbsp;',
      )}`,
      `${tabToEmsp(
        '- <a href="https://opus.se/tjanster/registreringsbesiktning/">Registreringsbesiktning</a>\t\t\t\t- Garagering',
      )}`,
      `${tabToEmsp(
        '- <a href="https://opus.se/tjanster/kontrollbesiktning/enskilt-godkannande/">Enskilt godkännande</a>&emsp;&nbsp;\t\t\t\t- Extra öppethållande',
      )}`,
      `${tabToEmsp('- Besiktning av lyftplattform&nbsp;&nbsp;\t\t\t- Besiktning hos kund')}`,
      `${tabToEmsp('- Besiktning av ADR&nbsp;\t\t\t\t\t- Fasta tider')}`,
      '- Upphandlingskontroll',
      '- Diagnostjänster',
      '- <a href="https://opus.se/tjanster/frivilliga-fordonstester/">Opus Fordonstester</a>',
      '- <a href="https://opus.se/tjanster/fukttest/">Opus Fukttest</a>',
    ],
  },
]

export const servicesPrivate: ServiceLinkSection[] = [
  {
    name: 'Kontrollbesiktning av',
    items: [
      { title: 'Personbil', href: 'https://opus.se/tjanster/kontrollbesiktning/personbil/' },
      { title: 'Motorcykel', href: 'https://opus.se/tjanster/kontrollbesiktning/mc/' },
      { title: 'Tunga fordon', href: 'https://opus.se/tjanster/kontrollbesiktning/tunga-fordon/' },
      { title: 'A-traktor', href: 'https://opus.se/tjanster/kontrollbesiktning/a-traktor/' },
      { title: 'Husvagn', href: 'https://opus.se/tjanster/kontrollbesiktning/husvagn/' },
      { title: 'Husbil', href: 'https://opus.se/tjanster/kontrollbesiktning/husbil/' },
      { title: 'Släpvagn', href: 'https://opus.se/tjanster/kontrollbesiktning/slapvagn/' },
    ],
  },
  {
    name: 'Frivilliga fordonstester',
    items: [
      { title: 'E-test', href: 'https://opus.se/tjanster/frivilliga-fordonstester/opus-e-test/' },
      { title: 'Fordonstester', href: 'https://opus.se/tjanster/frivilliga-fordonstester/' },
      { title: 'Gasolkontroll', href: 'https://opus.se/tjanster/frivilliga-fordonstester/gasolkontroll/' },
      { title: 'Opus fukttest', href: 'https://opus.se/tjanster/fukttest/' },
      {
        title: 'Vägning av Husvagn & Husbil',
        href: 'https://opus.se/tjanster/frivilliga-fordonstester/vagning-av-husvagn-husbil/',
      },
      {
        title: 'Veteranfordonstest',
        href: 'https://opus.se/tjanster/frivilliga-fordonstester/opus-veteranfordonstest/',
      },
    ],
  },
  {
    name: undefined,
    items: [
      { title: 'Efterkontroll', href: 'https://opus.se/tjanster/efterkontroll/' },
      { title: 'Registreringsbesiktning', href: 'https://opus.se/tjanster/registreringsbesiktning/' },
      { title: 'Maskinbesiktning', href: undefined },
    ],
  },
  {
    name: undefined,
    items: [
      { title: 'Tjänsten Hämta-besikta-lämna', href: 'https://opus.se/tjanster/hamta-lamna/' },
      { title: 'Enskilt godkännande', href: 'https://opus.se/tjanster/kontrollbesiktning/enskilt-godkannande/' },
      { title: 'Läs mer på opus.se', href: 'http://opus.se' },
    ],
  },
]
